__turbopack_context__.v({
  "boxContainer": "ProductLineItem-module-scss-module__SXPDbG__boxContainer",
  "checked": "ProductLineItem-module-scss-module__SXPDbG__checked",
  "content": "ProductLineItem-module-scss-module__SXPDbG__content",
  "copy": "ProductLineItem-module-scss-module__SXPDbG__copy",
  "heading": "ProductLineItem-module-scss-module__SXPDbG__heading",
  "hiddenCheckbox": "ProductLineItem-module-scss-module__SXPDbG__hiddenCheckbox",
  "imageContainer": "ProductLineItem-module-scss-module__SXPDbG__imageContainer",
  "imageContainer34": "ProductLineItem-module-scss-module__SXPDbG__imageContainer34",
  "link": "ProductLineItem-module-scss-module__SXPDbG__link",
  "shopAll": "ProductLineItem-module-scss-module__SXPDbG__shopAll",
});
